module.exports = __webpack_public_path__ + "static/joyful_6-87d64ff6b60a64072926fe6336312b84.png";